// Serializers
import BroadcastPostSerializer from "issara-sdk/types/BroadcastPostSerializer_apps_PRX";

// Types
import {
  BroadcastDataFirebase,
  RunSequence as MeFormRunSequence
} from "./MeFormType";

import {
  RunSequence as MeCastRunSequence,
  BroadcastMode,
  BroadcastEditorActions
} from "./MeCastType";

export type SequenceName = "MeForm" | "MeCast";

export type BroadcastAdapterContext<TRunSequence> = {
  sequence: SequenceName;
  runSequence: TRunSequence;
  mode: BroadcastMode;
  selectedBroadcast?: BroadcastPostSerializer;
  selectedFirebase?: BroadcastDataFirebase;
};

export type MeFormBroadcastAdapterProps = {
  mode: BroadcastMode;
  runSequence: MeFormRunSequence;
  selectedBroadcast?: BroadcastPostSerializer;
  selectedFirebase?: BroadcastDataFirebase;
};

export type MeCastBroadcastAdapterProps = {
  mode: BroadcastMode;
  runSequence: MeCastRunSequence;
  selectedBroadcast?: BroadcastPostSerializer;
  selectedFirebase?: BroadcastDataFirebase
};

const createBaseBroadcastAdapter = <TRunSequence extends Function>({
  sequence,
  runSequence,
  selectedFirebase,
}: {
  sequence: "MeForm" | "MeCast";
  runSequence: TRunSequence;
  selectedFirebase?: BroadcastDataFirebase;
}): Omit<BroadcastEditorActions, "onSubmit" | "getPatientByLeaf"> => ({
  updateContent: async (content) => {
    if (!selectedFirebase?.id) return;

    await runSequence({
      sequence,
      action: "UPDATE_CONTENT",
      content,
      id: selectedFirebase.id,
    });
  },

  uploadImage: async (params) => {
    if (!selectedFirebase?.id) return;

    await runSequence({
      sequence,
      action: "UPDATE_CONTENT",
      id: selectedFirebase.id,
      ...params,
    });
  },

  uploadImageBefore: ({ files, info, uploadHandler }) => {
    if (!selectedFirebase?.id) {
      return undefined;
    }

    runSequence({
      sequence,
      action: "UPDATE_CONTENT",
      id: selectedFirebase.id,
      files,
      info,
    }).then((res: any) => {
      uploadHandler({
        result: [
          {
            url: res?.url,
            name: files[0].name,
            size: files[0].size,
          },
        ],
      });
    });

    return undefined;
  },

  uploadImageError: (errorMessage, result) => {
    console.warn("[uploadImageError]", { errorMessage, result });
  },

  resizeEditor: () => {},

  calculateCredit: (params) => {
    runSequence({
      sequence,
      action: "GET_POST_CALCULATE_CREDIT",
      calculateParams: params,
    });
  },
});

export const createMeFormBroadcastAdapter = ({
  runSequence,
  selectedFirebase
}: MeFormBroadcastAdapterProps): BroadcastEditorActions => ({
  ...createBaseBroadcastAdapter({
    sequence: "MeForm",
    runSequence,
    selectedFirebase,
  }),

  onSubmit: (data) => {
    runSequence({
      sequence: "MeForm",
      action: "POST_BROADCAST",
      createdData: data,
    });
  },

  getPatientByLeaf: async () => {},
});

export const createMeCastBroadcastAdapter = ({
  mode,
  runSequence,
  selectedBroadcast,
  selectedFirebase
}: MeCastBroadcastAdapterProps): BroadcastEditorActions => ({
  ...createBaseBroadcastAdapter({
    sequence: "MeCast",
    runSequence,
    selectedFirebase
  }) as BroadcastEditorActions,

  onSubmit: (data) => {
    runSequence({
      sequence: "MeCast",
      action: mode === "CREATE" ? "POST_BROADCAST" : "UPDATE_BROADCAST",
      createdData: data,
      ...(mode !== "CREATE" && selectedBroadcast
        ? { broadcastPostId: selectedBroadcast.id }
        : {}),
    } as any);
  },

  getPatientByLeaf: async (pdrNodeId, nodeId, publishedDiagRuleId) => {
    await runSequence({
      sequence: "MeCast",
      action: "GET_PATIENT_BY_LEAF",
      pdrNodeId,
      nodeId,
      publishedDiagRuleId,
    });
  },
});

// export const MeFormBroadcastAdapter = ({
//   mode,
//   runSequence,
//   selectedBroadcast,
//   selectedFirebase
// }: MeFormBroadcastAdapterProps): BroadcastEditorActions => ({
//   updateContent: async (content) => {
//     if (!selectedFirebase?.id) return;

//     await runSequence({
//       sequence: "MeForm",
//       action: "UPDATE_CONTENT",
//       content,
//       id: selectedFirebase.id,
//     });
//   },

//   uploadImage: async ({
//     targetImgElement,
//     index,
//     contentAction,
//     imageInfo,
//     remainingFilesCount
//   }) => {
//     if (!selectedFirebase?.id) return;

//     await runSequence({
//       sequence: "MeForm",
//       action: "UPDATE_CONTENT",
//       id: selectedFirebase.id,
//       targetImgElement,
//       index,
//       contentAction,
//       imageInfo
//     });
//   },

//   uploadImageBefore: ({
//     files,
//     info,
//     uploadHandler
//   }) => {
//     if (!selectedFirebase?.id) return;

//     runSequence({
//       sequence: "MeForm",
//       action: "UPDATE_CONTENT",
//       id: selectedFirebase.id,
//       files,
//       info
//     }).then((res: any) => {
//       const resp = {
//         result: [
//           {
//             url: res?.url,
//             name: files[0].name,
//             size: files[0].size,
//           },
//         ],
//       };

//       uploadHandler(resp);
//     });

//     return undefined;
//   },

//   uploadImageError: (errorMessage, result) => {
//     console.warn("[handleImageUploadError]: ", { errorMessage, result });
//   },

//   resizeEditor: (height, prevHeight) => {
//     return;
//   }, 

//   calculateCredit: (params) => {
//     runSequence({
//       sequence: "MeForm",
//       action: "GET_POST_CALCULATE_CREDIT",
//       calculateParams: params,
//     });
//   },

//   onSubmit: (data) => {
//     runSequence({
//       sequence: "MeForm",
//       action: "POST_BROADCAST",
//       createdData: data,
//     });
//   },

//   getPatientByLeaf: async (nodeId, publishedDiagRuleId) => {
//     return;
//   },
// });

// export const MecastBroadcastAdapter = ({
//   mode,
//   runSequence,
//   selectedBroadcast,
//   selectedFirebase
// }: MeCastBroadcastAdapter): BroadcastEditorActions => ({
//   updateContent: async (content) => {
//     if (!selectedFirebase?.id) return;

//     await runSequence({
//       sequence: "MeCast",
//       action: "UPDATE_CONTENT",
//       content,
//       id: selectedFirebase.id,
//     } as any);
//   },

//   uploadImage: async ({
//     targetImgElement,
//     index,
//     contentAction,
//     imageInfo,
//     remainingFilesCount
//   }) => {
//     if (!selectedFirebase?.id) return;

//     await runSequence({
//       sequence: "MeCast",
//       action: "UPDATE_CONTENT",
//       id: selectedFirebase.id,
//       targetImgElement,
//       index,
//       contentAction,
//       imageInfo
//     });
//   },

//   uploadImageBefore: ({files, info, uploadHandler}) => {
//     if (!selectedFirebase?.id) return;

//     runSequence({
//       sequence: "MeCast",
//       action: "UPDATE_CONTENT",
//       id: selectedFirebase.id,
//       files,
//       info
//     } as any).then((res: any) => {
//       const resp = {
//         result: [
//           {
//             url: res?.url,
//             name: files[0].name,
//             size: files[0].size,
//           },
//         ],
//       };

//       uploadHandler(resp);
//     });

//     return undefined;
//   },

//   uploadImageError: (errorMessage, result) => {
//     console.warn("[handleImageUploadError]: ", { errorMessage, result });
//   },

//   resizeEditor: (height, prevHeight) => {
//     return;
//   }, 

//   calculateCredit: (params) => {
//     runSequence({
//       sequence: "MeCast",
//       action: "GET_POST_CALCULATE_CREDIT",
//       calculateParams: params,
//     });
//   },

//   onSubmit: (data) => {
//     runSequence({
//       sequence: "MeCast",
//       action: mode === "CREATE" ? "POST_BROADCAST" : "UPDATE_BROADCAST",
//       createdData: data,
//       ...(mode !== "CREATE" && selectedBroadcast ? { broadcastPostId: selectedBroadcast.id } : {}),
//     } as any);
//   },

//   getPatientByLeaf: async (nodeId, publishedDiagRuleId) => {
//     await runSequence({
//       sequence: "MeCast",
//       action: "GET_PATIENT_BY_LEAF",
//       nodeId,
//       publishedDiagRuleId,
//     })
//   },
// });